var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CToaster',{attrs:{"autohide":3000,"position":"top-center"}},[(_vm.message)?[_c('CToast',{key:_vm.message,class:_vm.type,attrs:{"show":true}},[_vm._v(" "+_vm._s(_vm.getMessage)+" ")])]:_vm._e()],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }